// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "calendar-" + chunkId + ".js?v=" + "9a1aa4e77ec802149729" + "";
};